import ls from 'local-storage'
import store from '@/store'
const requireAuth = (to, from, next) => {
  let path = to.path
  let split = path.split('/')
  store.dispatch('setPath', split[1])
  let token = ls.get('authen')
  if (!token) {
    next({
      path: '/login'
    })
  } else {
    next()
  }
}

export default {
  requireAuth
}



// WEBPACK FOOTER //
// ./src/router/auth.js